import { fromJS } from 'immutable';
import { SET_LOG } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  gameId: null,
  entries: null,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOG:
      // Entries stay plain objects: they're only read, by describeEntry.
      return state.set('gameId', action.payload.gameId).set('entries', action.payload.entries);

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
